import * as React from 'react'

/**
 * @description TravelVacation icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { TravelVacation } from '@sravni/design-system-icons'
 *
 * <TravelVacation />
 * ```
 */
export const TravelVacation = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="TravelVacation" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#TravelVacation__a)"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2.736 7c0-3 4-6 8-6s8 3 8 6h-16ZM10.736 13V7" />
      <path d="M7.736 6.952c0-3.258 1.343-5.9 3-5.9s3 2.642 3 5.9M5.826 16l-1.09 3M14.646 16l1.09 3M3.236 16h11.098a5 5 0 0 0 3-1l1.802-1.35a1.5 1.5 0 1 0-1.8-2.4l-1.802 1.35c-.346.26-.767.4-1.2.4H3.236a1.5 1.5 0 0 0 0 3v0Z" />
    </g>
    <defs>
      <clipPath id="TravelVacation__a">
        <path fill="currentColor" transform="translate(.736)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
))
